var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.featureIncluded && _vm.featureDetails
    ? _c(
        "dd",
        {
          class: `${_vm.plan.slug} cell text-center padding-sm strong margin-bottom-0 display-flex`,
          staticStyle: {
            "background-color": "var(--white)",
            border: "var(--border-width-sm) solid var(--fa-lt-gravy)",
            flex: "1 0 0px",
            "place-content": "center",
            overflow: "hidden",
          },
        },
        [
          _vm.featureDetails === "Unlimited"
            ? _c(
                "span",
                {
                  attrs: {
                    "aria-label": `${_vm.featureDetails}`,
                    "data-balloon-pos": "right",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "decorative",
                    attrs: { icon: _vm.$v6.solid.faInfinity, size: "lg" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "included in the " + _vm._s(_vm.plan.name) + " plan"
                    ),
                  ]),
                ],
                1
              )
            : _c("span", [
                _vm._v("\n    " + _vm._s(_vm.featureDetails) + "\n    "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("included in the " + _vm._s(_vm.plan.name) + " plan"),
                ]),
              ]),
        ]
      )
    : _vm.featureIncluded
    ? _c(
        "dd",
        {
          class: `${_vm.plan.slug} cell flex-column text-center padding-sm margin-bottom-0 display-flex`,
          staticStyle: {
            "background-color": "var(--white)",
            border: "var(--border-width-sm) solid var(--fa-lt-gravy)",
            flex: "1 0 0px",
            "place-content": "center",
          },
        },
        [
          _c("span", [
            _c(
              "span",
              {
                attrs: {
                  "aria-label": "Included",
                  "data-balloon-pos": "right",
                },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "decorative",
                  attrs: { icon: _vm.$v6.solid.faCircleCheck, size: "xl" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Included in the " + _vm._s(_vm.plan.name) + " plan"),
                ]),
              ],
              1
            ),
          ]),
        ]
      )
    : _c(
        "dd",
        {
          class: `${_vm.plan.slug} cell flex-column text-center padding-sm margin-bottom-0 display-flex`,
          staticStyle: {
            "background-color": "var(--white)",
            color: "var(--fa-gravy)",
            border: "var(--border-width-sm) solid var(--fa-lt-gravy)",
            flex: "1 0 0px",
            "place-content": "center",
          },
        },
        [
          _c("span", [
            _c(
              "span",
              {
                attrs: {
                  "aria-label": "Not Included",
                  "data-balloon-pos": "right",
                },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "decorative",
                  attrs: { icon: _vm.$v6.solid.faBan, size: "xl" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(
                    "Not Included in the " + _vm._s(_vm.plan.name) + " plan"
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }